import React, { useEffect, useState } from 'react';
import api from '../services/api';

const Agenda = () => {
  const [agendamentos, setAgendamentos] = useState([]);
  
  // Inicia com a data de hoje formatada (YYYY-MM-DD)
  const [dataFiltro, setDataFiltro] = useState(new Date().toISOString().split('T')[0]);
  
  // Estado para controlar a edição
  const [editando, setEditando] = useState(null);

  const carregarAgenda = () => {
    api.get(`/admin/agendamentos?data=${dataFiltro}`)
      .then(res => setAgendamentos(res.data))
      .catch(err => console.error(err));
  };

  useEffect(() => {
    carregarAgenda();
  }, [dataFiltro]);

  const getStatusStyle = (status) => {
    switch(status.toLowerCase()) {
      case 'confirmado': return { bg: '#F4F0EA', color: '#8B7355', label: 'Confirmado' };
      case 'pendente': return { bg: '#FCF8F2', color: '#C19B76', label: 'Aguardando' };
      case 'cancelado': return { bg: '#FDF5F5', color: '#A67C7C', label: 'Cancelado' };
      default: return { bg: '#F4F0EA', color: '#8B7355', label: status };
    }
  };

  const deletarAgendamento = async (id) => {
    if(window.confirm("Deseja realmente apagar esta consulta do sistema?")) {
      try {
        await api.delete(`/admin/agendamentos/${id}`);
        carregarAgenda();
      } catch (e) {
        alert("Erro ao excluir.");
      }
    }
  };

  const salvarEdicao = async (e) => {
    e.preventDefault();
    try {
      await api.put(`/admin/agendamentos/${editando.id}`, editando);
      alert("Agendamento atualizado com sucesso!");
      setEditando(null);
      carregarAgenda();
    } catch (err) {
      alert("Erro ao atualizar agendamento.");
    }
  };

  // Formatador bonito para a data do título
  const dataFormatada = new Date(dataFiltro + 'T12:00:00').toLocaleDateString('pt-BR', { weekday: 'long', day: 'numeric', month: 'long' });

  return (
    <div style={styles.container}>
      
      {/* SE MODO DE EDIÇÃO ESTIVER ABERTO */}
      {editando ? (
        <div style={styles.editCard}>
          <h2 style={styles.title}>Editar Consulta</h2>
          <form onSubmit={salvarEdicao} style={styles.form}>
            <div style={styles.row}>
              <div style={styles.inputGroup}>
                <label style={styles.label}>Data</label>
                <input type="date" value={editando.data} onChange={e => setEditando({...editando, data: e.target.value})} style={styles.input} />
              </div>
              <div style={styles.inputGroup}>
                <label style={styles.label}>Início</label>
                <input type="time" value={editando.hora_inicio} onChange={e => setEditando({...editando, hora_inicio: e.target.value})} style={styles.input} />
              </div>
              <div style={styles.inputGroup}>
                <label style={styles.label}>Fim</label>
                <input type="time" value={editando.hora_fim} onChange={e => setEditando({...editando, hora_fim: e.target.value})} style={styles.input} />
              </div>
            </div>
            
            <div style={styles.row}>
              <div style={{...styles.inputGroup, flex: 2}}>
                <label style={styles.label}>Paciente</label>
                <input type="text" value={editando.paciente} onChange={e => setEditando({...editando, paciente: e.target.value})} style={styles.input} />
              </div>
              <div style={styles.inputGroup}>
                <label style={styles.label}>Telefone</label>
                <input type="text" value={editando.telefone} onChange={e => setEditando({...editando, telefone: e.target.value})} style={styles.input} />
              </div>
            </div>

            <div style={styles.row}>
              <div style={styles.inputGroup}>
                <label style={styles.label}>Procedimento</label>
                <select value={editando.tipo} onChange={e => setEditando({...editando, tipo: e.target.value})} style={styles.input}>
                  <option value="Primeira Consulta">Primeira Consulta</option>
                  <option value="Retorno">Retorno</option>
                  <option value="Procedimento">Procedimento Estético</option>
                </select>
              </div>
              <div style={styles.inputGroup}>
                <label style={styles.label}>Status</label>
                <select value={editando.status} onChange={e => setEditando({...editando, status: e.target.value})} style={styles.input}>
                  <option value="confirmado">Confirmado</option>
                  <option value="pendente">Aguardando</option>
                  <option value="cancelado">Cancelado</option>
                </select>
              </div>
            </div>

            {/* CAMPO DE OBSERVAÇÕES ADICIONADO NA EDIÇÃO */}
            <div style={styles.row}>
              <div style={styles.inputGroup}>
                <label style={styles.label}>Observações Particulares</label>
                <textarea 
                  value={editando.descricao || ''} 
                  onChange={e => setEditando({...editando, descricao: e.target.value})} 
                  style={styles.textarea}
                  placeholder="Queixas, notas do paciente, etc..."
                />
              </div>
            </div>

            <div style={styles.rowButtons}>
              <button type="button" onClick={() => setEditando(null)} style={styles.btnCancel}>Voltar</button>
              <button type="submit" style={styles.btnSave}>Salvar Alterações</button>
            </div>
          </form>
        </div>
      ) : (
        /* LISTAGEM NORMAL DA AGENDA */
        <>
          <header style={styles.header}>
            <h1 style={styles.title}>Agenda do Dia</h1>
            <p style={styles.subtitle}>{dataFormatada}</p>
            
            <div style={styles.datePickerContainer}>
              <label style={styles.datePickerLabel}>Ir para a data:</label>
              <input 
                type="date" 
                value={dataFiltro} 
                onChange={(e) => setDataFiltro(e.target.value)}
                style={styles.datePickerInput}
              />
            </div>
          </header>

          <div style={styles.list}>
            {agendamentos.length > 0 ? agendamentos.map(appt => {
              const status = getStatusStyle(appt.status);
              return (
                <div key={appt.id} style={styles.card}>
                  <div style={styles.timeSection}>
                    <span style={styles.time}>{appt.hora_inicio}</span>
                    <span style={styles.duration}>até {appt.hora_fim}</span>
                  </div>
                  <div style={styles.infoSection}>
                    <h3 style={styles.pacienteName}>{appt.paciente}</h3>
                    <span style={styles.procedimentoType}>{appt.tipo}</span>
                    <div style={styles.contactInfo}>WhatsApp: {appt.telefone}</div>
                    
                    {/* EXIBIÇÃO DAS OBSERVAÇÕES NO CARD */}
                    {appt.descricao && (
                      <div style={styles.observacoesBox}>
                        <strong>Nota:</strong> {appt.descricao}
                      </div>
                    )}
                  </div>
                  
                  <div style={styles.actionSection}>
                    <span style={{...styles.badge, backgroundColor: status.bg, color: status.color}}>{status.label}</span>
                    
                    <div style={styles.buttonGroup}>
                      <button onClick={() => setEditando(appt)} style={styles.actionBtn} title="Editar Consulta">✏️</button>
                      <button onClick={() => deletarAgendamento(appt.id)} style={styles.actionBtnDel} title="Remover">🗑️</button>
                    </div>
                  </div>
                </div>
              );
            }) : (
              <div style={styles.emptyState}>Sua agenda está livre para esta data.</div>
            )}
          </div>
        </>
      )}
    </div>
  );
};

const styles = {
  container: { padding: '40px 20px', backgroundColor: '#FAF8F5', minHeight: '100vh', fontFamily: '"Montserrat", sans-serif' },
  header: { marginBottom: '40px', textAlign: 'center', display: 'flex', flexDirection: 'column', alignItems: 'center' },
  title: { fontSize: '32px', color: '#2C2A29', margin: 0, fontFamily: '"Playfair Display", serif', fontWeight: '500' },
  subtitle: { color: '#7A7571', fontSize: '14px', marginTop: '8px', textTransform: 'uppercase', letterSpacing: '1px' },
  
  datePickerContainer: { marginTop: '20px', display: 'flex', alignItems: 'center', gap: '10px', backgroundColor: '#FFF', padding: '10px 20px', borderRadius: '30px', border: '1px solid #EBE6E0' },
  datePickerLabel: { fontSize: '12px', fontWeight: '600', color: '#7A7571', textTransform: 'uppercase' },
  datePickerInput: { border: 'none', outline: 'none', fontSize: '14px', color: '#B59978', fontFamily: '"Montserrat", sans-serif', fontWeight: '600', cursor: 'pointer', backgroundColor: 'transparent' },

  list: { display: 'flex', flexDirection: 'column', gap: '16px', maxWidth: '850px', margin: '0 auto' },
  card: { display: 'flex', alignItems: 'flex-start', backgroundColor: '#FFFFFF', padding: '24px', borderRadius: '12px', border: '1px solid #EBE6E0', transition: 'box-shadow 0.3s' },
  timeSection: { display: 'flex', flexDirection: 'column', alignItems: 'center', minWidth: '90px', paddingRight: '20px', borderRight: '1px solid #EBE6E0', marginTop: '4px' },
  time: { fontSize: '20px', fontWeight: '500', color: '#B59978', fontFamily: '"Playfair Display", serif' },
  duration: { fontSize: '11px', color: '#7A7571', textTransform: 'uppercase', letterSpacing: '0.5px', marginTop: '4px' },
  infoSection: { flex: 1, paddingLeft: '24px' },
  pacienteName: { margin: 0, fontSize: '18px', color: '#2C2A29', fontWeight: '500' },
  procedimentoType: { fontSize: '13px', color: '#B59978', display: 'block', marginTop: '4px', textTransform: 'uppercase', letterSpacing: '0.5px' },
  contactInfo: { fontSize: '13px', color: '#7A7571', marginTop: '8px' },
  
  // Estilo elegante para as observações
  observacoesBox: { marginTop: '12px', padding: '10px 14px', backgroundColor: '#FCFBF9', borderRadius: '8px', fontSize: '12.5px', color: '#5D5A58', borderLeft: '3px solid #B59978', lineHeight: '1.4' },

  actionSection: { paddingLeft: '20px', display: 'flex', flexDirection: 'column', alignItems: 'flex-end', gap: '12px' },
  badge: { padding: '6px 14px', borderRadius: '4px', fontSize: '11px', fontWeight: '500', textTransform: 'uppercase', letterSpacing: '0.5px' },
  buttonGroup: { display: 'flex', gap: '8px' },
  actionBtn: { background: '#FCFBF9', border: '1px solid #EBE6E0', padding: '8px', borderRadius: '6px', cursor: 'pointer', fontSize: '14px' },
  actionBtnDel: { background: '#FDF5F5', border: '1px solid #F8D7DA', padding: '8px', borderRadius: '6px', cursor: 'pointer', fontSize: '14px' },

  emptyState: { textAlign: 'center', padding: '60px', color: '#A09B96', fontSize: '15px', fontFamily: '"Playfair Display", serif', fontStyle: 'italic' },

  editCard: { backgroundColor: '#FFFFFF', padding: '40px', borderRadius: '12px', border: '1px solid #EBE6E0', maxWidth: '700px', margin: '0 auto' },
  form: { display: 'flex', flexDirection: 'column', gap: '20px', marginTop: '20px' },
  row: { display: 'flex', gap: '16px', flexWrap: 'wrap' },
  inputGroup: { flex: 1, minWidth: '150px', display: 'flex', flexDirection: 'column' },
  label: { fontSize: '11px', fontWeight: '500', color: '#7A7571', marginBottom: '6px', textTransform: 'uppercase' },
  input: { padding: '12px', borderRadius: '8px', border: '1px solid #EBE6E0', backgroundColor: '#FCFBF9', outline: 'none', fontSize: '14px' },
  
  // Estilo para o textarea na edição
  textarea: { padding: '12px', borderRadius: '8px', border: '1px solid #EBE6E0', backgroundColor: '#FCFBF9', outline: 'none', fontSize: '14px', resize: 'vertical', minHeight: '80px', fontFamily: '"Montserrat", sans-serif' },

  rowButtons: { display: 'flex', justifyContent: 'flex-end', gap: '12px', marginTop: '10px' },
  btnCancel: { padding: '12px 24px', backgroundColor: '#FCFBF9', border: '1px solid #EBE6E0', borderRadius: '8px', cursor: 'pointer', color: '#7A7571', fontWeight: '600' },
  btnSave: { padding: '12px 24px', backgroundColor: '#B59978', border: 'none', borderRadius: '8px', cursor: 'pointer', color: '#FFF', fontWeight: '600' }
};

export default Agenda;